// prettier-ignore

const sicentificBoard = [
  { position: 'position.univ_professor', affiliation: 'affiliation.lucian_blaga_university_of_sibiu', name: 'Constantin Chiriac' },
  { position: 'position.univ_professor', affiliation: 'affiliation.lucian_blaga_university_of_sibiu', name: 'Cristian Radu' },
  { position: 'position.univ_professor', affiliation: 'affiliation.hong_kong_metropolitan_university', name: 'Octavian Saiu' },
  { position: 'position.principal_lecturer', affiliation: 'affiliation.leeds_beckett_university', name: 'Teresa Brayshaw' },
  // '',
  { position: 'position.univ_professor', affiliation: 'affiliation.new_sorbonne_university_paris_3', name: '✝ George Banu', special: true },
  { position: 'position.univ_professor', affiliation: 'affiliation.leeds_beckett_university', name: '✝ Noel Witts', special: true }
]

const walkOfFame = [
  'Ariane Mnouchkine',
  'Declan Donnellan',
  'Eugenio Barba',
  'Silviu Purcărete',
  'Gigi Căciuleanu',
  'Krystian Lupa',
  'Lev Dodin',
  '✝ Peter Brook',
  'Peter Stein',
  'Klaus Maria Brandauer',
  '✝ Eimuntas Nekrošius',
  'Joël Pommerat',
  'Neil LaBute',
  'Kazuyoshi Kushida',
  'Alvis Hermanis',
  'Christoph Marthaler',
  'Evgeny Mironov',
  'Thomas Ostermeier',
  'Luk Perceval',
  'Tim Robbins',
  'Vasile Șirli',
  'Philippe Genty',
  '✝ Rimas Tuminas',
  'Ohad Naharin',
  'Robert Wilson',
  'Mikhail Baryshnikov',
  'Ioan Holender',
  'Isabelle Huppert',
  'Wajdi Mouawad',
  'Hideki Noda',
  'Peter Sellars',
  'Sidi Larbi Cherkaoui',
  'Pippo Delbono',
  'Stan Lai',
  'Michael Thalheimer',
  'Emmanuel Demarcy-Mota'
]

const editorialBoard = [
  {
    position: 'position.univ_professor',
    affiliation: 'affiliation.lucian_blaga_university_of_sibiu',
    name: 'Constantin Chiriac',
    title: 'title.president'
  },
  {
    position: 'position.univ_professor',
    affiliation: 'affiliation.lucian_blaga_university_of_sibiu',
    name: 'Cristian Radu',
    title: 'title.editor_in_chief'
  },
  {
    position: 'position.univ_professor',
    affiliation: 'affiliation.lucian_blaga_university_of_sibiu',
    name: 'Ion M. Tomuș',
    title: 'title.associate_editor'
  },
  {
    position: 'position.assoc_professor',
    affiliation: 'affiliation.lucian_blaga_university_of_sibiu',
    name: 'Andrei Șerban',
    title: 'title.managing_editor'
  },
  {
    position: 'position.phd_assoc_professor',
    affiliation: 'affiliation.lucian_blaga_university_of_sibiu',
    name: 'Diana Nechit',
    title: 'title.secretary'
  }
]

export { sicentificBoard, walkOfFame, editorialBoard }
